import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const grey = {
  100: '#030303',
  200: '#1C1C1E',
  250: '#353535',
  300: '#424242',
  400: '#8C8C8C',
  500: '#B2B2B2',
  600: '#D0D0D0',
  700: '#E8E8E8',
  800: '#F2F2F2',
  900: '#FFFEFE',
  // TODO: these definitions are in MUI but not with ours, see where used and defined them correctly
  50: '#8C8C8C',
  A100: '#8C8C8C',
  A200: '#8C8C8C',
  A400: '#8C8C8C',
  A700: '#8C8C8C',
} satisfies Partial<Color>
